import { cn } from '@/utils/style'

interface SnapshotRestoreCounterProps {
  total: number
  used: number
}

export function SnapshotRestoreCounter({ total, used }: SnapshotRestoreCounterProps) {
  const remaining = total - used

  const getTextColorClass = (count: number) => {
    if (count === 0) return 'text-error'
    if (count >= 1 && count <= 3) return 'text-[#FF8447]'
    return 'text-tertiary'
  }

  const getCountColorClass = (count: number) => {
    if (count === 0) return 'text-error'
    if (count >= 1 && count <= 3) return 'text-[#FF8447]'
    return 'text-primary'
  }

  return (
    <div className="px-4 py-2 rounded-full bg-neutral-50 t-x-sb flex items-center gap-x-2">
      <div className={cn(getTextColorClass(remaining))}>Snapshot restores left</div>
      <div className={cn(getCountColorClass(remaining))}>
        {remaining} / {total}
      </div>
    </div>
  )
}
